@if (component?.columns?.length) {
<div class="pos-relative"
     [attr.id]="component.element_id"
     [ngClass]="component.width || ''">
    <div [ngClass]="[component.align_vertical || '']"
         [grid]="component?.grid_size"
         [gridColumnGap]="component.grid_gap || 0"
         [gridRowGap]="component.grid_gap || 0">
        @for (column of component?.columns; track $index) {
        <icms-outlet [fullHeight]="true"
                     [gridColumn]="column.size"
                     [gridColumnOffset]="column.offset"
                     [name]="'Column'"
                     [components]="column.components" />
        }
    </div>
</div>
}